import formatText from './format-text';

export default function setSummary(summary) {
  return formatText(summary);
}
